var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18.000000pt",
    height: "18.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000,24.000000) scale(0.0500000,-0.0500000)",
    fill: "currentcolor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376 404 c-3 -9 -13 -14 -21 -10 -20 7 -28 -10 -15 -34 7 -13 7 -20 0 -20 -5 0 -10 -7 -10 -16 0 -11 6 -14 20 -9 13 4 22 1 26 -9 8 -20 30 -21 38 -1 3 9 11 15 18 13 14 -3 18 9 11 30 -3 7 0 18 6 26 13 15 5 27 -15 19 -8 -3 -17 2 -20 11 -8 21 -30 21 -38 0z m39 -49 c0 -23 -34 -33 -45 -14 -13 20 1 40 24 37 13 -2 21 -10 21 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 360 c3 -11 0 -20 -6 -20 -6 0 -11 7 -11 16 0 14 -3 14 -15 4 -8 -7 -15 -21 -15 -30 0 -10 -4 -20 -10 -22 -6 -2 -3 -18 7 -40 15 -34 47 -58 77 -58 22 0 66 40 66 60 0 10 6 21 13 23 8 4 9 8 2 14 -6 4 -17 22 -24 38 -11 23 -15 26 -18 13 -6 -25 -23 -23 -23 2 0 14 -7 20 -24 20 -19 0 -23 -4 -19 -20z m63 -85 c0 -9 -11 -21 -25 -27 -21 -9 -28 -8 -45 7 -30 27 -25 35 25 35 34 0 45 -4 45 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 270 c0 -5 -8 -10 -18 -10 -14 0 -19 -8 -19 -30 0 -22 5 -30 18 -30 9 0 20 -6 23 -12 5 -10 7 -10 12 0 3 6 14 12 23 12 13 0 18 8 18 30 0 22 -5 30 -19 30 -10 0 -18 5 -18 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z m26 -31 c10 -17 -13 -36 -27 -22 -12 12 -4 33 11 33 5 0 12 -5 16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 158 c-40 -20 -45 -27 -48 -60 l-3 -38 160 0 161 0 0 26 c0 39 -16 60 -60 78 -60 24 -156 21 -210 -6z m200 -24 c22 -9 40 -22 40 -30 0 -11 -26 -14 -131 -14 -116 0 -130 2 -127 17 7 39 145 56 218 27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixitLogo);
export default __webpack_public_path__ + "static/media/FixitLogo.51fd6a3dbf943a6af9dec834e820c9b2.svg";
export { ForwardRef as ReactComponent };